import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllYoutubeSimilarInfluencers.graphql';
import { Query, QueryallYoutubeSimilarInfluencersArgs } from '../../__generated__/globalTypes';

export const useAllYoutubeSimilarInfluencersQuery = (
  options?: QueryHookOptions<Query, QueryallYoutubeSimilarInfluencersArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryallYoutubeSimilarInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllYoutubeSimilarInfluencersLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryallYoutubeSimilarInfluencersArgs>
): QueryResult<Query, QueryallYoutubeSimilarInfluencersArgs> & {
  getAllYoutubeSimilarInfluencers: LazyQueryExecFunction<Query, QueryallYoutubeSimilarInfluencersArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAllYoutubeSimilarInfluencers, result] = useLazyQuery<Query, QueryallYoutubeSimilarInfluencersArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllYoutubeSimilarInfluencers, ...result };
};

export const useAllYoutubeSimilarInfluencersPromiseQuery = () => {
  const client = useApolloClient();

  const getAllYoutubeSimilarInfluencers = useCallback(
    (options?: Omit<QueryOptions<QueryallYoutubeSimilarInfluencersArgs, Query>, 'query'>) =>
      client.query<Query, QueryallYoutubeSimilarInfluencersArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllYoutubeSimilarInfluencers };
};
// Suspense Query Hooks
export const useAllYoutubeSimilarInfluencersSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryallYoutubeSimilarInfluencersArgs>
) => {
  const result = useSuspenseQuery<Query, QueryallYoutubeSimilarInfluencersArgs>(QUERY, {
    ...options
  });

  return result;
};
